module.exports = __webpack_public_path__ + "static/media/ic_close_bold.3e275298.svg";